import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: true,
};

export const tokenErrorSlice = createSlice({
  name: "tokenError",
  initialState,
  reducers: {
    tokenError: (state, action) => {
      state.value = action.payload;
    },
  },
});

export const { tokenError } = tokenErrorSlice.actions;

export default tokenErrorSlice.reducer;
